(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifFullcalendarParams', swifFullcalendarParams)
    .controller('SwifFullCalendarController', SwifFullCalendarController);


    function swifFullcalendarParams() {
        return {
            restrict: 'AE',
            replace: true,
            require: 'ngModel',
            templateUrl: 'partials/ui/fullcalendar_params.html',
            scope: {
                view: '='
            },
            link: function (scope, element, attr, ngModel) {
                scope.hiddenDays = {};
                ngModel.$render = function () {
                    scope.fullcalendar = ngModel.$viewValue;
                    _.forEach(scope.fullcalendar.hiddenDays, function (day) {
                        scope.hiddenDays[day] = true;
                    });
                };
                scope.$watch('hiddenDays', function (newV, oldV) {
                    if (oldV !== undefined && scope.fullcalendar) {
                        scope.fullcalendar.hiddenDays = [];
                        _.forOwn(newV, function (value, key) {
                            if (value) {
                                scope.fullcalendar.hiddenDays.push(_.parseInt(key));
                            }
                        });
                    }
                }, true);

            }
        };
    }

    function SwifFullCalendarController($scope, swif) {
        'ngInject';
        $scope.$watch('fullcalendar', function (newV){
            swif.fullcalendar.updateFullCalendar(newV);
        }, true);
    }

})();
